enum Availability {
	Error = 0,
	Immediate = 1,
	Delayed = 2,
	Unavailable = 3
}

export default Availability